import classNames from 'classnames'
import styles from './styles.module.scss'

type FitOptionProps = {
  onSelect: (
    optionValue: string,
    event: React.MouseEvent<HTMLButtonElement>
  ) => void
  optionValue: string
  label?: string
  active?: boolean
  classes?: string
  selected?: boolean
  isOutOfStockSizeSelector?: boolean
}

const FitOption = ({
  optionValue,
  label,
  onSelect,
  selected = false,
  active = false,
  classes = ''
}: FitOptionProps) => {
  const isPillStyle = (label || optionValue)?.trim().length > 2
  const optionClasses = classNames(classes, `${styles.options__item}`, {
    [styles.selected]: selected,
    [styles.active]: active,
    [styles.pillOption]: isPillStyle,
    [styles.outOfStockSizeSelector]: !active
  })

  return (
    <button
      type="button"
      className={optionClasses}
      onClick={ev => {
        onSelect(optionValue, ev)
      }}
    >
      {label || optionValue}
    </button>
  )
}

export default FitOption
